<template>
  <baseEdit />
</template>

<script>
  import baseEdit from './baseEdit';

  export default {
    name: 'withholdingEdit',
    components: {
      baseEdit,
    },
  };
</script>
